import { push } from 'react-router-redux';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { setSubmissionStage } from 'actions';
import { submissionStages } from 'common/forms/submissionStages';

export const FORM_CONFIRM_REQUEST = 'FORM_CONFIRM_REQUEST';
export const FORM_CONFIRM_COMPLETE = 'FORM_CONFIRM_COMPLETE';
export const OPEN_FORM_CONFIRMATION = 'OPEN_FORM_CONFIRMATION';
export const CLOSE_FORM_CONFIRMATION = 'CLOSE_FORM_CONFIRMATION';

function request() {
  return {
    type: FORM_CONFIRM_REQUEST,
  };
}

function complete() {
  return {
    type: FORM_CONFIRM_COMPLETE,
  };
}

function open() {
  return {
    type: OPEN_FORM_CONFIRMATION,
    isFormConfirmationShown: true
  };
}

function close() {
  return {
    type: CLOSE_FORM_CONFIRMATION,
    isFormConfirmationShown: false
  };
}

export function showFormConfirmation() {
  return (dispatch) => {
    dispatch(open());
  };
}

export function hideFormConfirmation() {
  return (dispatch) => {
    dispatch(close());
  };
}

export function confirmForm(formType, id) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .confirm(id)
      .then((response) => {
        dispatch(complete());
        if (response.data.data) {
          dispatch(push(`/forms/${ formType }/${ id }/success`));
        } else {
          dispatch(setSubmissionStage(submissionStages.Certification));
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, complete, true, false));
        }
      });

    return promise();
  };
}

export function confirmFormGroup(formGroupType, id) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .confirmFormGroup(id)
      .then((response) => {
        dispatch(complete());
        if (response.data.data) {
          dispatch(push(`/forms/groups/${ formGroupType }/${ id }/success`));
        } else {
          dispatch(setSubmissionStage(submissionStages.Certification));
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, complete, true, false));
        }
      });

    return promise();
  };
}
